import { connect } from "react-redux";

const mapStateToProps = props => state =>
  props.reduce((result, prop) => {
    if (typeof prop === "string") result[prop] = state[prop];

    if (typeof prop === "object") {
      Object.keys(prop).forEach(key => {
        const value = prop[key];
        if (typeof value === "string") result[key] = state[value];
        if (typeof value === "function") result[key] = value(state);
      });
    }

    return result;
  }, {});

export default (...props) => Component =>
  connect(mapStateToProps(props))(Component);
